// AI: This is a new component created to encapsulate company form logic.
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Client, CompanyForm, EndCustomer } from 'src/app/api/models';
import { CompanyFormsService } from 'src/app/api/services';

@Component({
  selector: 'app-company-form-fields',
  templateUrl: './company-form-fields.component.html',
})
export class CompanyFormFieldsComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;
  @Input() entity: Client | EndCustomer;
  @Input() editMode: boolean;

  companyForms: CompanyForm[] = [];

  constructor(private companyFormsService: CompanyFormsService) {}

  ngOnInit(): void {
    this.companyFormsService.listCompanyForms().subscribe(forms => {
      // AI: Sort company forms to show most common ones first, using their codes for stability.
      const favoriteOrder = ['TOIMINIMI', 'OY', 'OYJ'];
      this.companyForms = forms.sort((a, b) => {
        const aIsFavorite = favoriteOrder.includes(a.code);
        const bIsFavorite = favoriteOrder.includes(b.code);

        if (aIsFavorite && !bIsFavorite) {
          return -1;
        }
        if (!aIsFavorite && bIsFavorite) {
          return 1;
        }
        if (aIsFavorite && bIsFavorite) {
          return favoriteOrder.indexOf(a.code) - favoriteOrder.indexOf(b.code);
        }
        return a.description_fi.localeCompare(b.description_fi);
      });
    });
  }

  getCompanyFormDescription(): string {
    if (!this.entity) {
      return '-';
    }
    if (this.entity.country === 'FI') {
      const form = this.companyForms.find(f => f.code === this.entity.company_form_code);
      return form?.description_fi || this.entity.company_form_code || '-';
    }
    return this.entity.company_form_other || '-';
  }
}
